/**
 * Reads the AIChatShell ACTIONS context. Throws if used outside its provider.
 *
 * Actions-only read path for the Shell slice (openChatbot / closeChatbot / toggleChatbot /
 * setChatbotWidth). Consumers that only dispatch should prefer this hook over
 * useAIChatShell() so they subscribe to the stable action object and never re-render on Shell
 * state changes.
 */
import { useContext } from 'react';
import { AIChatShellActionsContext } from './AIChatShellProvider';
import type { AIChatShellActions } from './AIChatShellProvider';

export function useAIChatShellActions(): AIChatShellActions {
  const context = useContext(AIChatShellActionsContext);
  if (!context) {
    throw new Error('useAIChatShellActions must be used within a AIChatShellProvider');
  }
  return context;
}
